module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/devices/devices.component.scss
// module id = ./src/app/entities/devices/devices.component.scss
// module chunks = main